<template>
  <el-dialog
    :title="title"
    width="800px"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form
      ref="form"
      :inline="true"
      label-position="right"
      :model="form"
      :rules="formRules"
      label-width="100px"
    >
      <div class="form-title">客户信息</div>
      <el-form-item class="form-item-half" label="手机号" prop="mobile">
        <el-input
          :disabled="isDetail || phoneDisabled"
          size="mini"
          maxlength="11"
          placeholder="请输入手机号"
          v-model="form.mobile"
          @input="handleChangeMobile"
          @blur="handleUpdateMobile"
        ></el-input>
      </el-form-item>
      <el-form-item class="form-item-half" label="姓名" prop="name">
        <el-input
          :disabled="isDetail"
          size="mini"
          maxlength="30"
          placeholder="请输入姓名"
          v-model="form.name"
        ></el-input>
      </el-form-item>
      <el-form-item class="form-item-half" label="性别" prop="gender">
        <el-radio-group v-model="form.gender" :disabled="isDetail">
          <el-radio v-for="item in genderList" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item class="form-item-half" label="微信号" prop="wechat">
        <el-input
          :disabled="isDetail"
          size="mini"
          maxlength="30"
          placeholder="请输入微信号"
          v-model="form.wechat"
        ></el-input>
      </el-form-item>
      <el-form-item class="form-item-half" label="居住地区" prop="residentialDistrict">
        <OrderRegion :address="form.residentialDistrict" :disabled="isDetail" @change="(e) => { form.residentialDistrict=e }"></OrderRegion>
      </el-form-item>
      <!-- 是否有客户来源（可能是线下） -->
      <el-form-item v-if="customerSourceDisplay" class="form-item-half" label="客户来源" prop="customerSource">
        <el-select
          size="mini"
          v-model="customerSourceDisplay"
          disabled
        >
          <el-option v-for="item in customerFlowSourcesOptions" :key="item.dataValue" :label="item.dataDisplay" :value="item.dataValue"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-else class="form-item-half" label="客户来源" prop="customerSource">
        <el-select
          size="mini"
          v-model="form.customerSource"
          placeholder="请选择"
          :disabled="isDetail"
        >
          <el-option v-for="item in customerFlowSourcesOptions" :key="item.dataValue" :label="item.dataDisplay" :value="item.dataValue"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="intentionLevelDisplay" class="form-item-half" label="意向级别" prop="intentionLevel">
        <el-select
          size="mini"
          v-model="intentionLevelDisplay"
          disabled
        >
          <el-option v-for="item in customerIntentionLevels" :key="item.dataValue" :label="item.dataDisplay" :value="item.dataValue"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-else class="form-item-half" label="意向级别" prop="intentionLevel">
        <el-select
          size="mini"
          v-model="form.intentionLevel"
          placeholder="请选择"
          :disabled="isDetail"
        >
          <el-option v-for="item in customerIntentionLevels" :key="item.dataValue" :label="item.dataDisplay" :value="item.dataValue"></el-option>
        </el-select>
      </el-form-item>
      <div class="form-title">到店记录</div>
      <el-form-item class="form-item-half" label="到店类型" prop="arrivalType">
        <el-select
          size="mini"
          v-model="form.arrivalType"
          placeholder="请选择到店类型"
          :disabled="isDetail || (form.mobile && isGetCustInfoByPhone)"
        >
          <el-option
            v-for="item in customerArrivalTypes"
            :key="item.dataValue"
            :label="item.dataDisplay"
            :value="item.dataValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="form-item-half" label="陪同情况" prop="accompanyType">
        <el-select
          size="mini"
          v-model="form.accompanyType"
          placeholder="请选择"
          :disabled="isDetail"
          @change="handleChangeAccompanyType"
        >
          <el-option
            v-for="item in customerAccompanyTypes"
            :key="item.dataValue"
            :label="item.dataDisplay"
            :value="item.dataValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="isHasAccompany" class="form-item-half" label="陪同人数" prop="accompanyNum">
        <el-input-number size="mini" v-model="form.accompanyNum" :min="1" :max="100" :step="1" step-strictly :disabled="isDetail"></el-input-number>
        <span class="accompany-num-text">人</span>
      </el-form-item>
      <div class="date-box">
        <el-form-item label="到店时间" prop="arrivalDate">
          <el-date-picker
            v-model="form.arrivalDate"
            type="date"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            :disabled="isDetail" 
            :pickerOptions="{
              disabledDate(time) {
                // return time.getTime() > new Date(form.arrivalDate)
                return time.getTime() > Date.now() || time.getTime() < new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000)
              }
            }"
             @change="handleChangeArrivalDate"
          >
          </el-date-picker>
        </el-form-item>
        <div class="separation">-</div>
        <el-form-item prop="arrivalMoment">
          <el-time-select
            :disabled="isDetail" 
            placeholder="请选择时间"
            v-model="form.arrivalMoment"
            :picker-options="{
              start: '00:00',
              step: '00:05',
              end: '23:55',
              maxTime: arrivalMomentMaxTime
            }" 
          >
          </el-time-select>
        </el-form-item>
      </div>
      <div class="date-box">
        <el-form-item label="离店时间" prop="leaveDate">
          <el-date-picker
            :disabled="isDetail" 
            v-model="form.leaveDate"
            type="date"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            :pickerOptions="{
              disabledDate(time) {
                return time.getTime() < new Date(form.arrivalDate) - 3600 * 1000 * 24 || time.getTime() > Date.now() || time.getTime() < new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000)
              }
            }"
            @change="handleChangeLeaveDate"
          >
          </el-date-picker>
        </el-form-item>
        <div class="separation">-</div>
        <el-form-item prop="leaveMoment">
          <el-time-select
            :disabled="isDetail" 
            placeholder="请选择时间"
            v-model="form.leaveMoment"
            :picker-options="{
              start: '00:00',
              step: '00:05',
              end: '23:55',
              // minTime: form.arrivalMoment
              maxTime: leaveMomentMaxTime
            }" 
          >
          </el-time-select>
        </el-form-item>
      </div>
      <el-form-item class="form-item-half" label="预约人员" prop="reservationStaff">
        <el-select
          size="mini"
          v-model="form.reservationStaff"
          filterable
          placeholder="请选择"
          :disabled="isDetail"
        >
          <el-option
            v-for="item in assignMembers"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="form-item-half" label="接待人员" prop="receptionStaff">
        <el-select
          size="mini"
          v-model="form.receptionStaff"
          filterable
          placeholder="请选择"
          :disabled="isDetail"
        >
          <el-option
            v-for="item in assignMembers"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="form-item-half" label="到店目的" prop="arrivalPurpose">
        <el-select
          :disabled="isDetail"
          :collapse-tags="!isDetail"
          multiple
          size="mini"
          v-model="form.arrivalPurpose"
          placeholder="请选择"
          @visible-change="handleVisibleChangeArrivalPurpose"
        >
          <el-option
            v-for="item in customerArrivalPurposes"
            :key="item.dataValue"
            :label="item.dataDisplay"
            :value="item.dataValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="isOtherReason" class="form-item-half" label="其他目的" prop="otherPurpose" :disabled="isDetail">
        <el-input :disabled="isDetail" size="mini" maxlength="200" placeholder="请输入" v-model="form.otherPurpose"></el-input>
      </el-form-item>
      <template>
       <div class="form-title">需求分析</div>
        <el-form-item class="form-item-half" label="意向车系" prop="intentionSeries">
          <el-select size="mini" v-model="form.intentionSeries" placeholder="请选择" :disabled="isDetail">
            <el-option v-for="item in seriesList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="form-item-half" label="现有车系" prop="ownedSeries">
          <el-select size="mini" v-model="form.ownedSeries" placeholder="请选择" filterable :disabled="isDetail">
            <el-option v-for="(item, index) in competitionSeriesClone" :key="index" :label="item.label" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="form-item-half" label="竞品车系" prop="comparisonSeries">
          <el-select size="mini" v-model="form.comparisonSeries" placeholder="请选择" filterable :disabled="isDetail">
            <el-option v-for="(item, index) in competitionSeriesClone" :key="index" :label="item.label" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="form-item-half" label="是否置换" prop="isReplacement">
          <el-select size="mini" v-model="form.isReplacement" placeholder="请选择" :disabled="isDetail">
            <el-option v-for="item in conditionSelectionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="form-item-half" label="付款方式" prop="paymentMethod">
          <el-select size="mini" v-model="form.paymentMethod" placeholder="请选择" :disabled="isDetail">
            <el-option v-for="item in payTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <div class="form-title">接待结果</div>
        <el-form-item class="form-item-half" label="是否试驾" prop="isTestDrive">
          <el-select size="mini" v-model="form.isTestDrive" placeholder="请选择" disabled>
            <el-option v-for="item in conditionSelectionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-button type="text" style="padding: 0;height:28px;" v-if="!isDetail" @click="getTestDriveInfo(form.mobile)">点击自动获取试驾信息</el-button>
         <div class="date-box">
          <el-form-item label="试驾开始时间" prop="testDriveStartDate">
            <el-date-picker
              disabled
              v-model="form.testDriveStartDate"
              type="date"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <div class="separation">-</div>
          <el-form-item prop="testDriveStartMoment">
            <el-time-select disabled v-model="form.testDriveStartMoment"></el-time-select>
          </el-form-item>
        </div>
        <div class="date-box">
          <el-form-item label="试驾结束时间" prop="testDriveEndDate">
            <el-date-picker
              disabled
              v-model="form.testDriveEndDate"
              type="date"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <div class="separation">-</div>
          <el-form-item prop="testDriveEndMoment">
            <el-time-select disabled v-model="form.testDriveEndMoment"></el-time-select>
          </el-form-item>
        </div>
        <el-form-item class="form-item-half" label="试驾车型">
          <el-input disabled size="mini" v-model="form.testDriveSpec"></el-input>
        </el-form-item>
        <el-form-item class="form-item-half" label="是否报价" prop="hasOffer">
          <el-select size="mini" v-model="form.hasOffer" placeholder="请选择" :disabled="isDetail">
            <el-option v-for="item in conditionSelectionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="form-item-half" label="是否订车" prop="hasBook">
          <el-select size="mini" v-model="form.hasBook" placeholder="请选择" :disabled="isDetail">
            <el-option v-for="item in conditionSelectionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="form-item-half" label="是否交车" prop="hasDeliver">
          <el-select size="mini" v-model="form.hasDeliver" placeholder="请选择" :disabled="isDetail">
            <el-option v-for="item in conditionSelectionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input :disabled="isDetail" style="width:400px;" type="textarea" :rows="3" placeholder="请输入备注内容" v-model="form.remark"></el-input>
        </el-form-item>
        <el-form-item label="下次跟进日期" :prop="isMobileOk ? 'nextDueDate' : ''" v-show="isMobileOk">
          <el-date-picker
            v-model="form.nextDueDate"
            type="date"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            :disabled="isDetail"
            :pickerOptions="{
              disabledDate(time) {
                const dataTime = Date.now()
                const oneDay = 3600 * 1000 * 24
                return time.getTime() > (dataTime + oneDay * 7) || time.getTime() < (dataTime - oneDay)
              }
            }"
          >
          </el-date-picker>
        </el-form-item>
      </template>
    </el-form>
    <span v-if="!isDetail" slot="footer" class="dialog-footer">
      <el-button :loading="isSubmitting" type="text" @click="handleConfirm">确 定</el-button>
      <el-button type="text" @click="handleClose">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { 
  genderList,
  conditionSelectionList,
  payTypeList,
  CONSTANT_99,
  CONSTANT_1,
  CONSTANT_2,
  getDateTime,
  CONSTANT_0,
  accompanyTypeHasNum
} from '../static/form-options'
import { mobileReg, registerRules } from '../static/form-rules'
import { mapActions } from 'vuex'
import dayjs from "dayjs";

export default {
  name: 'CustomerRecord',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    assignMembers: {
      type: Array,
      default: () => []
    },
    isDetail: {
      type: Boolean,
      default: false
    },
    flowId: {
      type: Number,
      default: null
    }
  },
  // model: {
  //   prop: 'visible',
  //   event: 'change'
  // },
  data() {
    return {
      genderList,
      conditionSelectionList,
      payTypeList,
      accompanyTypeHasNum: accompanyTypeHasNum,
      customerSourceDisplay: '',
      form: {
        name: '', // 客户信息
        gender: 1, // 性别
        mobile: '', // 手机号
        wechat: '', // 微信号
        residentialDistrict: [],// 居住地区
        customerSource: null, // 客户来源
        intentionLevel: null, // 意向级别
        accompanyType: null,// 陪同情况
        accompanyNum: null, // 陪同人数
        arrivalDate: '',// 到店日期
        arrivalMoment: '',// 到店时间
        leaveDate: '',// 离店日期
        leaveMoment: '',// 离店时间
        reservationStaff: null,// 预约人员
        receptionStaff: null,// 接待人员
        arrivalPurpose: [],// 到店目的
        otherPurpose: '',// 其他目的
        intentionSeries: null, // 意向车系
        ownedSeries: null,// 现有车系
        comparisonSeries: null,// 对比车系
        isReplacement: null,// 是否置换
        paymentMethod: null,// 付款方式
        isTestDrive: CONSTANT_2,// 是否试驾
        testDriveStartDate: null,// 试驾开始日期
        testDriveStartMoment: null,// 试驾开始时间
        testDriveEndDate: null,// 试驾结束日期
        testDriveEndMoment: null,// 试驾结束时间
        testDriveSpec: '', // 试驾车型
        hasOffer: null, // 是否报价
        hasBook: null, // 是否订车
        hasDeliver: null,// 是否交车
        remark: '',
        nextDueDate: getDateTime(Date.now() + 3600 * 1000 * 24).date // 跟进时间(默认T+1)
      },
      formRules: registerRules,
      profile: this.$common.getDealer(),
      competitionSeriesList: [],
      competitionSeriesClone: [],
      seriesList: [],// 意向车系
      // testDriveInfo: {},// 试驾信息
      isSubmitting: false,
      customerArrivalTypes: [], // 到店类型
      isGetCustInfoByPhone: false, // 是否根据手机号获取到客档信息
      verifyArrivalInfo: {},
      phoneDisabled: false, // 手机号是否可编辑
      intentionLevelDisplay: '',
    }
  },
  watch: {
    visible: {
      handler: function(val) {
        // 重置
        this.customerSourceDisplay = ''
        this.intentionLevelDisplay = ''
        if (!!val) {
          this.$nextTick(() => {
            this.$refs.form.resetFields()
            // 到店类型
            this.customerArrivalTypes = this.baseInfo.customerArrivalTypes
          })
          // 不要删，为了解决弹窗打开时间过长问题，因车系数据太长
          setTimeout(() => {
            this.competitionSeriesClone = [...this.competitionSeriesList]
          }, 20);
          // 获取详情
          this.getDetail()
          if (!this.isDetail) {
            this.getDealerRegion().then(origin => {
              const { province='', city='', county='' }= origin.dealerLocation
              this.form.residentialDistrict = [province, city, county]
            })
          }
        }
      },
      immediate: true
    },
  },
  computed: {
    title() {
      return this.isDetail ? '登记详情' : '离店登记'
    },
    baseInfo() {
      return this.$common.getBaseInfo()
    },
    // 客户来源
    customerFlowSources() {
      return this.baseInfo.customerFlowSources
    },
    customerFlowSourcesUnion() {
      return this.baseInfo.customerFlowSourcesUnion
    },
    customerFlowSourcesOptions() {
      return this.isDetail ? this.customerFlowSourcesUnion : this.customerFlowSources
    },
    // 客户意向级别
    customerIntentionLevels() {
      return this.baseInfo.customerIntentionLevels
    },
    // 陪同情况
    customerAccompanyTypes() {
      return this.baseInfo.customerAccompanyTypes
    },
    // 到店目的
    customerArrivalPurposes() {
      return this.baseInfo.customerArrivalPurposes
    },
    // 到店类型
    // customerArrivalTypes() {
    //   return this.baseInfo.customerArrivalTypes
    // },
    isOtherReason() {
      return this.form.arrivalPurpose.length && this.form.arrivalPurpose.includes(CONSTANT_99)
    },
    arrivalMomentMaxTime() {
      if (new Date(this.form.arrivalDate) < new Date(this.form.leaveDate)) {
        return '23:55'
      }
      return `${new Date().getHours()}:${new Date().getMinutes()}`
    },
    isHasAccompany() {
      return this.accompanyTypeHasNum.includes(this.form.accompanyType)
    },
    isMobileOk() {
      return this.form.mobile && this.form.mobile.length === 11 && mobileReg.test(this.form.mobile)
    },
    leaveMomentMaxTime() {
      if(this.form.leaveDate !== dayjs().format('YYYY-MM-DD')) {
        return ''
      }
      return `${new Date().getHours()}:${new Date().getMinutes()}`
    }
  },
  created() {
    // 获取竞品车系
    this.getCompetitionSeriesList()
    this.getSeriesList() // 获取意向车系
  },
  methods: {
    ...mapActions('user', ['getDealerRegion']),
    // 获取详情信息
    getDetail() {
      this.$httpAuth.post("/v2/appCustomerFlowService/flowDetail", { 
        flowId: this.flowId,
        dealerId: this.profile.dealerId
      }).then(e => {
        const data = e?.data?.data ?? {}
        if (this.isDetail && !data.accompanyType) {
          data.accompanyType = 1
        }
        if (this.isDetail && (data.intentionLevel === 6 || data.intentionLevel === 7)) {
          if (data.intentionLevel === 6) {
            this.intentionLevelDisplay = '订车'
          } else if (data.intentionLevel === 7) {
            this.intentionLevelDisplay = '交车'
          }
          this.form.intentionLevel = data.intentionLevel
        }
        this.form = { ...this.form, ...this.formatForm(data) }
        // 若关联了订单的客流状态为”接待中“，则需在离店的时候控制手机号不可编辑
        this.phoneDisabled = !!(data.orderId && data.flowStatus === 1)
        if (this.form.mobile && !this.isDetail) {
          // 到店信息验
          this.verifyArrival(this.form.mobile)
          // 获取试驾信息
          this.getTestDriveInfo(this.form.mobile)
        }
      })
    },
    formatForm(result) {
      const { residentialDistrict, nextDueDate, ...rest } = result;
      const form = rest
      form.customerSource = this.getDefaultValue(result.customerSource)
      form.intentionLevel = this.getDefaultValue(+result.intentionLevel)
      const { date: arrivalDate, moment: arrivalMoment } = this.getFormatTime(result.arrivalTimeStr);
      form.arrivalDate = arrivalDate
      form.arrivalMoment = arrivalMoment
      form.arrivalPurpose = result.arrivalPurpose ? result.arrivalPurpose.split(',').map(item =>Number(item)) : []
      form.intentionSeries =  this.getDefaultValue(result.intentionSeries)
      form.ownedSeries =  this.getDefaultValue(result.ownedSeries)
      form.reservationStaff =  this.getDefaultValue(result.reservationStaff)
      form.comparisonSeries =  this.getDefaultValue(result.comparisonSeries)
      form.isReplacement =  this.getDefaultValue(result.isReplacement)
      form.paymentMethod =  this.getDefaultValue(result.paymentMethod)
      form.hasOffer =  this.getDefaultValue(result.hasOffer)
      form.hasBook =  this.getDefaultValue(result.hasBook)
      form.hasDeliver =  this.getDefaultValue(result.hasDeliver)
      form.arrivalType = result.arrivalType || CONSTANT_1
      // 详情页展示接口数据
      if (this.isDetail) {
        form.residentialDistrict = result.residentialDistrict? result.residentialDistrict.split('-'): []
        const { date: leaveDate, moment: leaveMoment } = this.getFormatTime(result.leaveTimeStr);
        form.leaveDate = leaveDate
        form.leaveMoment = leaveMoment
        // 试驾信息
        const testDriveInfo = this.formatTestDriveInfo(result)
        Object.keys(testDriveInfo).forEach(key => {
          form[key] = testDriveInfo[key]
        })
        // 跟进时间
        form.nextDueDate = result.nextDueDate
      } else {
        // 默认当前时间
        const { date: leaveDate, moment: leaveMoment } = getDateTime()
        form.leaveDate = leaveDate
        form.leaveMoment = leaveMoment
      }
      return form
    },
    handleChangeArrivalDate(value) {
      // 到店时间不能大于当前时间
      if (value === dayjs().format('YYYY-MM-DD') && this.form.arrivalMoment && new Date(`${value} ${this.form.arrivalMoment}`) > new Date()) {
        const { moment: arrivalMoment } = getDateTime()
        this.form.arrivalMoment = arrivalMoment
      }
    },
    handleChangeLeaveDate(value) {
      // 离店时间不能大于当前时间
      if (value === dayjs().format('YYYY-MM-DD') && this.form.leaveMoment && new Date(`${value} ${this.form.leaveMoment}`) > new Date()) {
        const { moment: leaveMoment } = getDateTime()
        this.form.leaveMoment = leaveMoment
      }
    },
    getDefaultValue(value){
      return value === 0 || value === '' ? null : value
    },
    getFormatTime(timeStr){
      if (!timeStr) {
        return {
          date: '',
          moment: ''
        }
      }
      const result = timeStr.split(' ')
      if (result.length < 2) {
        throw new Error('时间格式不正确');
      }
      return {
        date: result[0],
        moment: result[1].slice(0,5)
      }
    },
    handleChangeAccompanyType() {
      this.form.accompanyNum = this.isHasAccompany ? (this.form.accompanyNum || CONSTANT_1) : null
    },
    // 根据手机号查询到店类型、接待人员等信息
    handleChangeMobile(e) {
      if (e.length === 11 && mobileReg.test(e)) {
        this.verifyArrival(e)
        this.getTestDriveInfo(e)
      }
    },
    handleUpdateMobile(){
      if (this.form.mobile.length !== 11 || !mobileReg.test(this.form.mobile)) {
        this.$message.error('请输入正确的手机号！')
        this.form = {
          ...this.form,
          // 重置到店信息
          arrivalType: CONSTANT_1,
          registerStaff: this.profile.userId,
          customerSource: null,
          testDriveId: null,
          customerId: 0,// 无客档id，默认传0
          // 重置试驾信息
          isTestDrive: CONSTANT_2,
          testDriveStartDate: '',
          testDriveStartMoment: '',
          testDriveEndDate: '',
          testDriveEndMoment: '',
          testDriveSpec: ''
        }
      }
    },
    getCompetitionSeriesList() {
      if (this.competitionSeriesList.length) return
      this.$httpAuth
        .post("/v1/dealerRpc/getCompetitionSeriesList", {
          dealerId: this.profile.dealerId,
          key: "",
        })
        .then(res=>{
          this.competitionSeriesList = res?.data?.data.map(item => ({...item, label: `${item.brandName} ${item.seriesName}`})) ?? []
        });
    },
    // 获取意向车系
    getSeriesList() {
      this.$httpAuth
        .post("/v1/dealerRpc/seriesList", {
          dealerId: this.profile.dealerId
        })
        .then(res => {
          this.seriesList = res.data.records;
        });
    },
    // 到店信息验
    verifyArrival(mobile) {
      this.$httpAuth.post("/v2/appCustomerFlowService/verifyArrival", { 
        mobile,
        dealerId: this.profile.dealerId
      }).then(e => {
          this.verifyArrivalInfo = e?.data?.data ?? {}
          const { arrivalType, registerStaff, registerStaffName, customerFlowSources={}, customerId } = this.verifyArrivalInfo
          // this.form.arrivalType = arrivalType
          this.form.registerStaff = registerStaffName ? registerStaff : this.profile.userId
          this.form.customerId = customerId
          this.form.customerSource = customerFlowSources.dataDisplay && customerFlowSources.dataValue ? customerFlowSources.dataValue: null
          this.customerSourceDisplay = customerFlowSources.dataDisplay
          this.handleFlowCustomerInfo(mobile)
        })
    },
    getTestDriveInfo(mobile) {
      this.$httpAuth.post("/v2/appCustomerFlowService/getTodayTestDriveInfo", { 
        mobile,
        dealerId: this.profile.dealerId
      }).then(e => {
        const testDriveInfo = this.formatTestDriveInfo(e?.data?.data ?? {})
        this.form = {
          ...this.form,
          ...testDriveInfo
        }
      })
    },
    formatTestDriveInfo(info={}) {
      const { testDriveStartTime='', testDriveEndTime='', testDriveId, testDriveSpec='' } = info
      const startTimeArr = testDriveStartTime?.split(' ') ?? []
      const endTimeArr = testDriveEndTime?.split(' ') ?? []
      return {
        testDriveStartTime,
        testDriveEndTime,
        testDriveId,
        isTestDrive: testDriveId !== 0 ? CONSTANT_1 : CONSTANT_2,
        testDriveStartDate: startTimeArr?.[0] ?? '',
        testDriveStartMoment: startTimeArr?.[1] ?? '',
        testDriveEndDate: endTimeArr?.[0] ?? '',
        testDriveEndMoment: endTimeArr?.[1] ?? '',
        testDriveSpec,
      }
    },
    handleClose() {
      // this.$refs.form.resetFields()
      this.$emit('change', false)
    },
    handleConfirm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const arrivalTime = `${this.form.arrivalDate} ${this.form.arrivalMoment}`
          const leaveTime = `${this.form.leaveDate} ${this.form.leaveMoment}`
          const flag = new Date(arrivalTime) >= new Date(leaveTime)
          if (flag) {
            this.$message.error('客户离店时间需要晚于到店时间，请检查并维护正确的到店/离店时间。')
            return
          }
          if (!dayjs(this.form.arrivalDate).isSame(dayjs(this.form.leaveDate))) {
            this.$message.error('客户离店时间需与到店时间在同一天，请检查并维护正确的到店/离店时间。')
            return
          }
          if (dayjs(this.form.arrivalDate).isBefore(dayjs().subtract(6, 'day').format('YYYY-MM-DD'))) {
            this.$message.error('客流到/离店时间需要限制在7天内，请重新选择')
            return
          }
          this.isSubmitting = true
          await this.handleRegisterLeave()
          this.$emit('change', false)
          setTimeout(() => {
            this.isSubmitting = false
          }, 1000);
        }
      })
    },
    getArrivalParams() {
      const { 
        name,
        gender,
        mobile,
        wechat,
        arrivalType,
        accompanyType,// 陪同情况
        accompanyNum, // 陪同人数
        arrivalDate,// 到店时间
        arrivalMoment,// 到店时间
        reservationStaff,// 预约人员
        receptionStaff,// 接待人员
        arrivalPurpose,// 到店目的
        otherPurpose,// 其他目的
      } = this.form;
      return {
        name,
        gender,
        mobile,
        wechat,
        arrivalType,
        accompanyType,
        accompanyNum,
        arrivalTime: `${arrivalDate} ${arrivalMoment}`,
        reservationStaff,
        receptionStaff,
        arrivalPurpose: arrivalPurpose.toString(),
        otherPurpose,
        dealerId: this.profile.dealerId,
      }
    },
    getLeaveParams() {
      const params = this.getArrivalParams();
      const { 
        residentialDistrict,// 居住地区
        customerSource,// 客户来源
        intentionLevel,// 意向级别
        leaveDate,//离店时间
        leaveMoment,//离店时间
        intentionSeries,// 意向车系
        ownedSeries,// 现有车系
        comparisonSeries,// 对比车系
        isReplacement,// 是否置换
        paymentMethod,// 付款方式
        hasOffer,//是否报价
        hasBook,//是否订车
        hasDeliver,//是否交车
        remark,//备注
        nextDueDate,
        customerId=CONSTANT_0,// 已存在的客档id，有值则回传
        testDriveStartTime,// 试驾开始时间
        testDriveEndTime,// 试驾结束时间
        testDriveSpec,// 试驾车型
        testDriveId,
      } = this.form;
      return {
        ...params,
        residentialDistrict: residentialDistrict.join('-'),
        customerSource,
        intentionLevel,
        leaveTime: `${leaveDate} ${leaveMoment}`,
        intentionSeries,
        ownedSeries,
        comparisonSeries,
        isReplacement,
        paymentMethod,
        hasOffer,
        hasBook,
        hasDeliver,
        remark,
        nextDueDate: this.isMobileOk ? nextDueDate : '',
        customerId,
        testDriveStartTime,
        testDriveEndTime,
        testDriveSpec,
        testDriveId,
      }
    },
    // 离店登记
    handleRegisterLeave() {
      const arrivalParams = this.getArrivalParams()
      const leaveParams = this.getLeaveParams()
      return new Promise((resolve, reject) => {
        try {
          this.$httpAuth.post("/v2/appCustomerFlowService/registerLeave", { 
            ...arrivalParams, 
            ...leaveParams,
            id: this.flowId
          }).then(e => {
            this.$message.success(e.data.detail)
            this.$emit('updateList')
            resolve()
          }).catch(error=> {
            this.isSubmitting = false
            reject(error)
          })
        } catch (error) {
          reject(error)
        }
      })
    },
    // 根据手机号获取客流对应的客档详情
    handleFlowCustomerInfo(mobile) {
      this.$httpAuth.post("/v2/appCustomerFlowService/getFlowCustomerInfo", { 
        mobile,
        dealerId: this.profile.dealerId
      }).then(e => {
        const data = e?.data?.data ?? {}
        if (data.name) {
          this.isGetCustInfoByPhone = true
          this.form.arrivalType = this.verifyArrivalInfo.arrivalType
          this.customerArrivalTypes = this.baseInfo.customerArrivalTypes
          if (!this.form.name && data.name) {
            this.form.name = data.name
          }
          if (data.gender) {
            this.form.gender = data.gender
          }
          if (!this.form.wechat && data.wechat) {
            this.form.wechat = data.wechat
          }
          if (data.customerSource && data.customerSource.dataDisplay) {
            this.customerSourceDisplay = data.customerSource.dataDisplay
            this.form.customerSource = data.customerSource.dataValue
          } else {
            this.customerSourceDisplay = ''
            this.form.customerSource = this.getDefaultValue(1)
          }
          if (data.intentionLevel) {
            if (data.intentionLevel === 6 || data.intentionLevel === 7) {
              const selectedcustomerLevel = this.baseInfo.customerLevels.filter(o => o.dataName === data.customerLevel) 
              if (selectedcustomerLevel && selectedcustomerLevel.length) {
                 this.intentionLevelDisplay = selectedcustomerLevel[0].dataDisplay
                 this.form.intentionLevel = +data.intentionLevel
              } else {
                this.intentionLevelDisplay = ''
                this.form.intentionLevel = this.getDefaultValue(+data.intentionLevel)
              }
            } else if (!this.form.intentionLevel) {
              this.intentionLevelDisplay = ''
              this.form.intentionLevel = this.getDefaultValue(+data.intentionLevel)
            }
          }
          if (data.residentialDistrict) {
            const residentialDistrictArr = data.residentialDistrict.split('_')
            this.form.residentialDistrict = [residentialDistrictArr[0] || '', residentialDistrictArr[1] || '', residentialDistrictArr[2] || '']
          }
        } else {
          this.isGetCustInfoByPhone = false
          this.customerSourceDisplay = ''
          this.intentionLevelDisplay = ''
          this.form.customerSource = this.getDefaultValue(1)
          this.form.arrivalType = 1
          this.customerArrivalTypes = this.baseInfo.customerArrivalTypes.filter(item => item.dataValue === 1 || item.dataValue === 2)
        }
      })
    },
    handleVisibleChangeArrivalPurpose(e) {
      if (!e && !this.form.arrivalPurpose.includes(CONSTANT_99)) {
        this.form.otherPurpose = ''
      }
    }
  }
}
</script>
<style scoped>
::v-deep .el-dialog {
  margin-top: 70px!important;
  max-height: 600px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

::v-deep .el-dialog__header {
  border-bottom: 1px solid rgb(231, 231, 232);;
  box-shadow: 0px 8px 20px 0px rgba(0, 0, 0, 0.02);
}

::v-deep .el-dialog__body {
  flex: 1;
  overflow: auto;
}

::v-deep .el-dialog__footer {
  border-top: 1px solid rgb(231, 231, 232);
  box-shadow: 0px 1px 16px 0px rgba(0, 0, 0, 0.04);
}

.el-input--mini {
  width: 260px;
}
.el-select--mini {
  width: 260px;
}

.form-title {
  font-size: 14px;
  font-weight: bolder;
  margin-bottom: 20px;
}

::v-deep .el-form-item {
  margin-bottom: 15px;
  margin-right: 0;
}

.form-item-half {
  width: 50%;
}

.el-radio + .el-radio {
  margin-top: 0;
}
/* 日期组件样式--start */
::v-deep .date-box {
  display: flex;
}
::v-deep .date-box .el-form-item {
  margin-right: 0;
}
.date-box ::v-deep .el-date-editor--data.el-input {
  width: 160px;
}
.date-box ::v-deep .el-date-editor--time-select.el-input {
  width: 140px;
}
.date-box ::v-deep .el-input__inner {
  height: 28px;
  line-height: 28px;
  padding-left: 26px;
  padding-right: 26px;
  font-size: 12px;
}
.date-box ::v-deep .el-input__icon {
  width: 14px;
  line-height: 28px;
}
.date-box .separation {
  margin: 6px 10px 0;
}
/* 日期组件样式--end */

.accompany-num-text {
  margin-left: 15px;
}
</style>